import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"
import { addCommasToNumber } from "../../../../../utils/helpers"
import PercentageChange from "./PercentageChange"

export function Card({
    children,
    title,
    measurementType,
    value,
    percentageChange = 0,
    width = "none"
}) {
    const safePercentageChange = percentageChange ?? 0

    return (
        <Box
            width={width}
            className="card-component"
            rounded="xl"
            bg="white"
            px="20px"
            py="16px"
            boxShadow="sm"
        >
            <Flex gap={5} align="center" bg="white" width="100%">
                <Box>{children}</Box>

                <Flex direction="column" flex="1" justifyContent="center" bg="white" align="flex-start">
                    <Text
                        color="gray.500"
                        fontSize="14px"
                        fontWeight="500"
                        mb={1}
                    >
                        {title}
                    </Text>

                    <Flex gap="1" bg="white" align="baseline" mb={1}>
                        <Text fontSize="20px" fontWeight="700" color="gray.800">
                            {addCommasToNumber(value)}
                        </Text>
                        <Text fontSize="12px" fontWeight="400" color="gray.500">
                            {measurementType}
                        </Text>
                    </Flex>

                    <PercentageChange percentageChange={safePercentageChange} />
                </Flex>
            </Flex>
        </Box>
    )
}
